/**
 * average the the values or the mapped return value of mapFn from the given
 * IterableCollection.
 *
 * @function mapFn
 * @param {*} value each value of obj
 * @returns {number} a number to average
 *
 * @param  {IterableCollection} obj
 * @param {mapFn} mapFn
 * @return {number}
 */
export default function average (obj, mapFn = v => v) {
  if (!this.isIterable(obj)) {
    throw new Error(`Cannot average non-iterable object: ${obj}`);
  }
  let numValues = 0;
  let total = 0;
  for (let value of this.values(obj)) {
    numValues++;
    total += mapFn(value);
  }
  return total / numValues;
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/average.js